import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from 'components/Box'
import Text from 'components/Text'

import { LeadOwnerChangedData } from 'services/types/notification'
import { Notification } from 'types/global'

import { Highlight } from './styles'
import NotificationHeader from './NotificationHeader'
import NotificationFooter from './NotificationFooter'

type Props = Notification & {
  data: LeadOwnerChangedData
}

const Assigned: React.FC<LeadOwnerChangedData> = ({ lead_name, new_value, updated_by_name }) => {
  const { t } = useTranslation()

  return (
    <Text lineHeight="22px">
      {t('lead_lbl')}
      <Highlight>{lead_name}</Highlight>
      {t('notification_lead_owner_assigned_to', { newValue: new_value })}
      {updated_by_name && (
        <>
          &nbsp;
          {t('by_name', { name: updated_by_name })}
        </>
      )}
    </Text>
  )
}

const Reassigned: React.FC<LeadOwnerChangedData> = ({ lead_name, new_value, old_value, updated_by_name }) => {
  const { t } = useTranslation()

  return (
    <Text lineHeight="22px">
      {t('lead_lbl')}
      <Highlight>{lead_name}</Highlight>
      {t('notification_lead_owner_reassigned_to', {
        newValue: new_value,
        oldValue: old_value,
      })}
      {updated_by_name && (
        <>
          &nbsp;
          {t('by_name', { name: updated_by_name })}
        </>
      )}
    </Text>
  )
}

const Unassigned: React.FC<LeadOwnerChangedData> = ({ lead_name, old_value, updated_by_name }) => {
  const { t } = useTranslation()

  return (
    <Text lineHeight="22px">
      {t('lead_lbl')}
      <Highlight>{lead_name}</Highlight>
      {t('notification_lead_owner_unassigned', { oldValue: old_value })}
      {updated_by_name && (
        <>
          &nbsp;
          {t('by_name', { name: updated_by_name })}
        </>
      )}
    </Text>
  )
}

const LeadOwnerUpdate: React.FC<Props> = (props) => {
  const { new_value, old_value } = props.data

  const getBody = () => {
    if (!old_value && new_value) {
      return <Assigned {...props.data} />
    }

    if (old_value && new_value) {
      return <Reassigned {...props.data} />
    }

    return <Unassigned {...props.data} />
  }

  return (
    <Box display="flex" paddingLeft="10px" width="100%" flexDirection="column">
      <NotificationHeader {...props} title="notification_lead_owner_title" />
      <Box display="flex" paddingTop="4px">
        {getBody()}
      </Box>
      <NotificationFooter {...props} />
    </Box>
  )
}

export default LeadOwnerUpdate
